<template>
  <div class="global-address-tag f-r">
    <div :title="addressCode" class="code" v-if="hasAddressCode">
      {{ addressCode }}
    </div>
    <span
      :title="shortFullAddress"
      class="address-full"
      style="overflow-wrap: break-word"
      v-else-if="hasAddress"
      >{{ shortFullAddress }}</span
    >
    <el-popover placement="right" :trigger="trigger">
      <basic-form
        v-if="hasAddress"
        class="global-address-info-basic-form"
        ref="addressInfo"
        title="Address Info"
        :mode="mode"
        :form-params="addressInfo"
      />
      <span v-else>No Address</span>
      <div slot="reference">
        <div class="magnify f-c-c-c" v-if="hasAddress">
          <svg-icon icon-class="info" class="svg-icon" />
        </div>
        <svg-icon v-else icon-class="ellipsis" class="svg-icon" />
      </div>
    </el-popover>
  </div>
</template>
<script>
import BasicForm from '@/components/common/BasicForm.vue'
import { FormModes } from '@/core/configs/types'
import { AddressInfoWrapUp } from '@/core/models/address'
export default {
  name: 'AddressTag',
  components: { BasicForm },
  props: {
    address: {
      required: true
    },
    trigger: {
      type: String,
      default: 'hover'
    },
    ellipsis: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mode: FormModes.SINGLE
    }
  },
  computed: {
    hasAddress() {
      return !!this.address
    },
    hasAddressCode() {
      return this.address && this.address.code
    },
    addressCode() {
      return this.address?.code ?? ''
    },
    simpleAddress() {
      return [this.address.street].join(', ')
    },
    shortFullAddress() {
      if (this.simpleAddress.length > 12) {
        return this.simpleAddress.slice(0, 12) + '...'
      }
      return this.simpleAddress
    },
    addressInfo() {
      return AddressInfoWrapUp(this.address)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.global-address-tag {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  align-items: center;
  gap: 3px;
}

.svg-icon {
  font-size: 18px;
  filter: $svg-info-color;
}

.magnify {
  font-size: 18px;

  &:hover {
    cursor: pointer;
    color: $deep-green;
  }
}

.code {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.address-full {
  overflow: hidden;
  word-break: break-word;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style lang="scss">
.global-address-info-basic-form {
  width: 300px;
  margin: 0;
  box-shadow: none;
  padding: 0 10px;
}
</style>
